import { render, staticRenderFns } from "./menu-item-group.vue?vue&type=template&id=543b7bdc&"
import script from "./menu-item-group.vue?vue&type=script&lang=js&"
export * from "./menu-item-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543b7bdc')) {
      api.createRecord('543b7bdc', component.options)
    } else {
      api.reload('543b7bdc', component.options)
    }
    module.hot.accept("./menu-item-group.vue?vue&type=template&id=543b7bdc&", function () {
      api.rerender('543b7bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/menu/src/menu-item-group.vue"
export default component.exports